import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const CheckoutFunnelErrorTranslationsProvider = createTranslationsPageProvider({
  checkout: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-checkout/translations/${brand}/${locale}/checkout_errors.js`)
});